var _rect, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 320",
    width: 800,
    height: 320,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 320,
    fill: "#ffffff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 135,
    fontFamily: "'Montserrat', 'Helvetica Neue', 'Arial Black', sans-serif",
    fontWeight: 900,
    fontSize: 100,
    fill: "#252627",
    letterSpacing: 8
  }, "\u041D\u041A\u0411")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 220,
    fontFamily: "'Montserrat', 'Helvetica Neue', 'Arial Black', sans-serif",
    fontWeight: 900,
    fontSize: 100,
    fill: "#252627",
    letterSpacing: 8
  }, "\u041C\u0415\u0422\u041E\u0414")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 305,
    fontFamily: "'Montserrat', 'Helvetica Neue', 'Arial', sans-serif",
    fontWeight: 300,
    fontSize: 80,
    fill: "#252627",
    textAnchor: "end",
    letterSpacing: 6
  }, "\u0410\u0414\u041C\u0418\u041D\u041A\u0410")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminLogo);
export default __webpack_public_path__ + "static/media/AdminLogo.1bc8cb88a5c884995a234bc0ab022f0a.svg";
export { ForwardRef as ReactComponent };